import API from '@/store/apiUtils'
import axios from 'axios'
import Vue from 'vue'

const settingsModule = {
  state: {
    whoWillContact: null,
    currentYearTimeFrames: [],
    currentYearTimeFramesLocal: [],
    nextYearTimeFrames: [],
    nextYearTimeFramesLocal: [],
    defaultSelectionCriteria: [],
    capacities: []
  },
  getters: {
    whoWillContact: state => state.whoWillContact,
    currentYearTimeFrames: state => state.currentYearTimeFrames,
    currentYearTimeFramesLocal: state => state.currentYearTimeFramesLocal,
    nextYearTimeFrames: state => state.nextYearTimeFrames,
    nextYearTimeFramesLocal: state => state.nextYearTimeFramesLocal,
    defaultSelectionCriteria: state => state.defaultSelectionCriteria
  },
  mutations: {
    setWhoWillContact(state, contact) {
      state.whoWillContact = contact || null
    },
    setCurrentYearTimeFrames(state, timeFrames) {
      state.currentYearTimeFrames = timeFrames || []
    },
    setCurrentYearTimeFramesLocal(state, timeFrames) {
      state.currentYearTimeFramesLocal = timeFrames || []
    },
    setNextYearTimeFrames(state, timeFrames) {
      state.nextYearTimeFrames = timeFrames || []
    },
    setNextYearTimeFramesLocal(state, timeFrames) {
      state.nextYearTimeFramesLocal = timeFrames || []
    },
    setDefaultSelectionCriteria(state, criteria) {
      state.defaultSelectionCriteria = criteria || []
    }
  },
  actions: {
    getGlobalRefData({ getters, commit }) {
      if (
        !getters.currentYearTimeFrames.length ||
        !getters.currentYearTimeFramesLocal.length ||
        !getters.nextYearTimeFrames.length ||
        !getters.nextYearTimeFramesLocal.length ||
        !getters.defaultSelectionCriteria.length
      ) {
        return API.get(
          `${process.env.VUE_APP_API_REFDATA}/global-web-content-ref.json`
        ).then(response => {
          commit('setWhoWillContact', response.data.local.whoWillContact)
          commit(
            'setCurrentYearTimeFrames',
            response.data.ooa.currentYearTimeFrames
          )
          commit(
            'setCurrentYearTimeFramesLocal',
            response.data.local.currentYearTimeFrames
          )
          commit('setNextYearTimeFrames', response.data.ooa.nextYearTimeFrames)
          commit(
            'setNextYearTimeFramesLocal',
            response.data.local.nextYearTimeFrames
          )
          commit('setDefaultSelectionCriteria', response.data.ooa.criteria)
          commit('setCapacities', response.data.ooa.capacity)
        })
      }

      return Promise.resolve()
    },
    getSavedSettings({ dispatch }) {
      // this will return a 403 error until the school saves their settings
      // for the first time.
      // use a separate axios instance to circumvent the default error handling in apiUtils
      const axiosInstance = axios.create()
      dispatch('showSpinner')
      return axiosInstance
        .get(
          `${process.env.VUE_APP_API_EA}/v1/ea/customisation`,
          {
            headers: { ...API.getHeaders(true), ...{  } }
          }
        )
        .then(response => {
          dispatch('hideSpinner')
          return response.data.body
        })
        .catch(() => {
          dispatch('hideSpinner')
          return null
        })
    },
   
    saveSettings({ rootState }, settings) {

      return API.put(
        `${process.env.VUE_APP_API_EA}/v1/ea/customisation`,
        settings,
        false
      )
    }
  }
}

export default settingsModule
